import { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { Public } from '../api.js';
import { PageHeader } from '../components/PageHeader.jsx';

const typeColors = {
  practice: '#4A6B3E',
  match: '#7A1C1C',
  social: '#B8935A',
  clubhouse_booking: '#55504A',
};

export default function Schedule() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    Public.events()
      .then((r) => {
        setEvents(
          r.events.map((e) => ({
            id: e.id,
            title: e.title,
            start: e.start,
            end: e.end,
            allDay: e.allDay,
            backgroundColor: typeColors[e.type] || '#1A1612',
            borderColor: typeColors[e.type] || '#1A1612',
            extendedProps: { type: e.type, location: e.location },
          })),
        );
      })
      .catch(() => setEvents([]));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12">
      <PageHeader eyebrow="Calendar" title="Schedule" description="Training, matches, socials, and clubhouse bookings." />
      <div className="flex items-center gap-4 flex-wrap mb-4 text-[11px] uppercase tracking-eyebrow text-ink-2">
        {[
          ['Practice', typeColors.practice],
          ['Match', typeColors.match],
          ['Social', typeColors.social],
          ['Clubhouse', typeColors.clubhouse_booking],
        ].map(([l, c]) => (
          <span key={l} className="inline-flex items-center gap-2">
            <span className="w-2 h-2 rounded-full" style={{ background: c }} />
            {l}
          </span>
        ))}
      </div>
      <div className="card p-3 md:p-5">
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
          initialView={window.innerWidth < 768 ? 'listWeek' : 'dayGridMonth'}
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,listWeek',
          }}
          events={events}
          height="auto"
          dayMaxEvents={3}
        />
      </div>
    </div>
  );
}
